import React, { useState } from 'react';
import './App.css';

function App() {
  const [formData, setFormData] = useState({
    title: '',
    email: '',
    issueDetail: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      // Using Formspree for easy integration - you'll need to replace this with your own Formspree endpoint
      const response = await fetch('https://formspree.io/f/mpwykplk', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: formData.title,
          email: formData.email,
          issue: formData.issueDetail,
          _subject: `Support Ticket: ${formData.title}`,
          _replyto: formData.email
        })
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ title: '', email: '', issueDetail: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="App">
      <div className="support-container">
        <div className="support-header">
          <div className="business-brand">
            <h2 className="business-name">Eighteen Degree</h2>
            <div className="business-tagline">Professional Support Services</div>
          </div>
          <h1>🆘 Support Center</h1>
          <p>We're here to help! Please describe your issue and we'll get back to you as soon as possible.</p>
        </div>

        <div className="support-form-container">
          <form onSubmit={handleSubmit} className="support-form">
            <div className="form-group">
              <label htmlFor="title">Issue Title *</label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Brief description of your issue"
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="your.email@example.com"
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="issueDetail">Issue Details *</label>
              <textarea
                id="issueDetail"
                name="issueDetail"
                value={formData.issueDetail}
                onChange={handleChange}
                placeholder="Please provide detailed information about your issue. Include steps to reproduce, error messages, or any other relevant details."
                required
                rows="6"
                className="form-textarea"
              />
            </div>

            <button 
              type="submit" 
              disabled={isSubmitting}
              className="submit-button"
            >
              {isSubmitting ? 'Submitting...' : 'Submit Support Request'}
            </button>

            {submitStatus === 'success' && (
              <div className="status-message success">
                ✅ Thank you! Your support request has been submitted successfully. We'll get back to you soon.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="status-message error">
                ❌ There was an error submitting your request. Please try again or contact us directly.
              </div>
            )}
          </form>
        </div>

        <div className="support-info">
          <h3>What happens next?</h3>
          <ul>
            <li>🔍 Our support team will review your request within 24 hours</li>
       
          </ul>
        </div>
      </div>
    </div>
  );
}

export default App;
